import { render, staticRenderFns } from "./btn-light-disabled.mpx?vue&type=template&id=e275fc28&isComponent&outputPath=components%2Fbtn-light-disabledaa039d68%2Findex"
import script from "./btn-light-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-light-disabledaa039d68%2Findex"
export * from "./btn-light-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-light-disabledaa039d68%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports